import stringify from 'json-stable-stringify';

export const MAX_EXPIRY_SECONDS = Number.MAX_SAFE_INTEGER;

export interface CacheEntry {
  expireTime: number;
  value: any;
}

export default class ExpirableCache {
  private ttl: number;
  private cache: Map<string, CacheEntry>;

  constructor(ttl = MAX_EXPIRY_SECONDS) {
    this.ttl = ttl;
    this.cache = new Map();
  }

  has(key: any): boolean {
    return this._hasHashedKey(this.hash(key));
  }

  get(key: any): any {
    const hashedKey = this.hash(key);
    return this._hasHashedKey(hashedKey) ? this.cache.get(hashedKey).value : null;
  }

  set(key: any, value: any, ttl = 0): any {
    const expireTtl = ttl || this.ttl;
    const expireTime = expireTtl === MAX_EXPIRY_SECONDS ? MAX_EXPIRY_SECONDS : Date.now() + expireTtl * 1000;
    this.cache.set(this.hash(key), {value, expireTime});
    return value;
  }

  clear(key): boolean {
    return this.cache.delete(this.hash(key));
  }

  clearAll(): void {
    this.cache = new Map();
  }

  hash(key: any): string {
    return stringify(key);
  }

  /** true if key hasn't expired, otherwise false and delete entry */
  private _hasHashedKey(hashedKey: string): boolean {
    if (this.cache.has(hashedKey)) {
      const entry = this.cache.get(hashedKey);
      if (Date.now() < entry.expireTime) {
        return true;
      } else {
        this.cache.delete(hashedKey);
      }
    }
    return false;
  }
}
